import { memo } from "react";

import EditorFrame from "@/components/editors/EditorFrame";
import { ScheduleCalendarViewItems } from "@/components/editors/template-blocks/service-menu/service-menu-items/ScheduleCalendarViewItems";
import { useSubmitForm } from "@/hooks/useSubmitForm";
import { ServiceMenuTemplate as IServiceMenuTemplate } from "@/states/page-editor/template-parts/service-menu";
import {
  useFormData,
  useServiceFormUiState,
  useServiceInfo,
} from "@/states/service-form/selectors";
import { CalendarServiceInfo } from "@/states/service-form/types";
import clsx from "clsx";
import { useRouter } from "next/router";

const ServiceMenuCalendarContent = ({
  part,
  isConfirm = false,
}: {
  part: IServiceMenuTemplate;
  isConfirm?: boolean;
}) => {
  const serviceFormUiState = useServiceFormUiState();
  const service = useServiceInfo() as CalendarServiceInfo;
  const router = useRouter();
  const { uuid } = router.query;
  const formData = useFormData();
  const { errors } = useSubmitForm();
  const handleSubmitCalendar = () => {
    if (typeof uuid === "string") {
      const menuId =
        serviceFormUiState?.status === "Loaded"
          ? serviceFormUiState.inputs?.service?.serviceMenuId
          : "";
      const optionIds =
        serviceFormUiState?.status === "Loaded"
          ? serviceFormUiState.inputs?.service?.serviceMenuOptionIds?.join(",")
          : "";
      const optionIdsQuery =
        optionIds && optionIds.length > 0 ? `&options=${optionIds}` : "";
      void router.push(
        `/form/${uuid}/select?service_menu_id=${menuId || ""}${optionIdsQuery}`,
      );
    }
  };
  const containerClass = isConfirm
    ? ""
    : "mx-[-16px] px-[16px] md:mx-[calc((-100vw+920px)/2)] md:px-[calc((100vw-920px)/2)]";
  return (
    <div
      className={containerClass}
      style={isConfirm ? {} : part?.bgCssProperties}
      id="menu"
    >
      {(errors?.service?.detailIds?.[0] || errors?.service?.optionIds?.[0]) &&
      formData.isSubmit === true ? (
        <p className="text-xl text-center text-accent form-error-text">
          {errors?.service?.detailIds?.[0] || errors?.service?.optionIds?.[0]}{" "}
        </p>
      ) : null}
      {serviceFormUiState.status === "Loaded" && (
        <EditorFrame noBorder isNoPadding>
          <div
            id="service-menu-calendar-template"
            className={clsx(
              "p-0 rounded-lg md:py-12",
              !isConfirm && "md:px-[150px]",
            )}
            style={part.frameCssProperties}
          >
            <ScheduleCalendarViewItems
              schedules={service?.menus}
              handleSubmitCalendar={handleSubmitCalendar}
              isConfirm={isConfirm}
            />
          </div>
        </EditorFrame>
      )}
    </div>
  );
};

export const ServiceMenuCalendarTemplate = memo(ServiceMenuCalendarContent);
